import { Link } from "react-router-dom";
import Social1 from "assets/icons/instagram.svg";
import Social2 from "assets/icons/facebook.svg";
import Social3 from "assets/icons/linkedin.svg";
import Social4 from "assets/icons/twitter.svg";
import Accr from "assets/png/accredited.png";
import "./footer.css";

const Footer = () => {
  return (
    <div className="footer bg-pry relative">
      <div className="foot pb-24 lg:pb-8">
        <div className="foot-one">
          <Link className="foot-logo white pry-text" to="/">
            NOBLE <span className="white">SECURE TECHNOLOGIES</span>
          </Link>
          <p className="content white pry-text">
            Elevate Your Security: Your Safety, Our Priority
          </p>

          <p className="ash subtitle pry-text mt-2 -mb-2">MEDIA</p>

          <div className="socials">
            <a
              href="https://instagram.com/nobleguardng"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Social1} alt="" />
            </a>
            <a
              href="https://www.facebook.com/nobleguardng/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Social2} alt="" />
            </a>
            <a
              href="https://twitter.com/nobleguardng"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Social4} alt="" />
            </a>
            <a
              href="https://ng.linkedin.com/company/nobleguardng"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Social3} alt="" />
            </a>
          </div>
        </div>

        <div className="foot-two">
          <p className="ash subtitle pry-text">COMPANY</p>
          <a className="content white pry-text" href="/#about">
            About
          </a>
          <Link className="content white pry-text" to="/blog">
            Blogs
          </Link>
          <a className="content white pry-text" href="/#contact">
            Contact
          </a>
          <Link className="content white pry-text" to="/privacy-policy">
            Privacy Policy
          </Link>
        </div>

        <div className="foot-two">
          <p className="ash subtitle pry-text">ACTIONS</p>
          <a className="content white pry-text" href="/#services">
            Services
          </a>
          <a className="content white pry-text" href="/#partners">
            Partners
          </a>
          <a className="content white pry-text" href="/#mission">
            Mission
          </a>
        </div>

        <div className="foot-two">
          <p className="ash subtitle pry-text">CONTACT US</p>

          <div className="addresses">
            <p className="content white pry-text medium">
              <span className="bold">Lagos:</span> Plot 1773 7th Avenue Festac,{" "}
              <br />
              Amuwo-Odofin.
            </p>
            <p className="content white pry-text medium">
              <span className="bold">Abuja:</span> 4th floor, Tower C Churchgate
              <br />
              plaza, Central Business District, Abuja.
            </p>
            <p className="content white pry-text medium ">
              <span className="bold">Imo:</span> 20 Assumpta Avenue, Control{" "}
              <br /> Post Owerri.
            </p>
            <p className="content white pry-text medium ">
              <span className="bold">Abia Umahia:</span> 3 Bende Road, EEDC
              Office <br /> <span className="bold">Aba:</span> 1 Geometric Power
              Road <br />
              Osisioma Industrial Layout
            </p>
            <p className="content white pry-text medium">
              <span className="bold">Other Branches:</span> Abuja,
              Port-Harcourt,
              <br />
              Kano, Ogun.
            </p>
          </div>

          <p className="content white pry-text medium ">+234 907 136 4105</p>
        </div>
      </div>

      <div className="absolute bottom-8 left-4 lg:left-20">
        <img src={Accr} alt="accredited logo" className="w-24 object-contain" />
      </div>
    </div>
  );
};

export default Footer;
